import { styled } from '@linaria/react'
import React, { ComponentProps, FC, PropsWithChildren } from 'react'
import { FontSize, FontWeight, Typography } from './Typography'
import { RouterLink } from './RouterLink'
import { Loader } from './Loader'
import { colors, ColorValue } from '../styles/colors'

export const ButtonLink: FC<
  PropsWithChildren & {
    to: string
    className?: string
    textColor?: ColorValue
    textWeight?: FontWeight
  }
> = ({
  to,
  children,
  className,
  textColor = colors.secondary,
  textWeight = 600,
}) => {
  return (
    <RouterLink to={to} style={{ display: 'block' }} className={className}>
      <Typography fontSize={16} fontWeight={textWeight} color={textColor}>
        {children}
      </Typography>
    </RouterLink>
  )
}

export const ButtonRegular: FC<
  ComponentProps<typeof ButtonStyled> & {
    loading?: boolean
    className?: string
    textColor?: ColorValue
    backgroundColor?: ColorValue
    textWeight?: FontWeight
    fontSize?: FontSize
    type?: 'button' | 'submit' | 'reset'
    isWithTypographyWrapper?: boolean
  }
> = ({
  children,
  loading,
  disabled,
  className,
  textColor = colors.secondary,
  textWeight = 600,
  type = 'button',
  fontSize = 16,
  isWithTypographyWrapper = true,
  ...props
}) => {
  if (isWithTypographyWrapper) {
    return (
      <ButtonStyled
        disabled={disabled || loading}
        type={type}
        className={className}
        {...props}
      >
        <Typography
          fontSize={fontSize}
          fontWeight={textWeight}
          color={textColor}
        >
          {loading ? <ButtonLoader /> : children}
        </Typography>
      </ButtonStyled>
    )
  } else {
    return (
      <ButtonStyled
        disabled={disabled || loading}
        type={type}
        className={className}
        {...props}
      >
        {loading ? <ButtonLoader /> : children}
      </ButtonStyled>
    )
  }
}

const ButtonLoader = styled(Loader)`
  svg {
    width: 20px;
    height: 20px;
  }
`
const ButtonStyled = styled.button<{ backgroundColor?: ColorValue }>`
  transition: opacity 0.2s;
  padding: 16px 20px;
  border-radius: 26px;
  cursor: pointer;
  text-align: center;
  background-color: ${props => props.backgroundColor ?? 'transparent'};
  &:disabled {
    opacity: 0.5;
  }
`
